import React, { useEffect } from 'react';
import { initMetaPixel, trackPixelEvent } from './utils/metaPixel';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PackContents } from './components/PackContents';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { LaunchOffer } from './components/LaunchOffer';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { EmotionalClose } from './components/EmotionalClose';
import { LegalNotice } from './components/LegalNotice';
import { Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
const TransitionPhrase = () => <div className="mx-auto max-w-3xl px-6 py-4 text-center" data-id="element-0" data-mp="28tmifcuwat1z">
    <p className="font-display text-xl font-[800] italic leading-relaxed text-brand-blue/85 md:text-3xl" data-id="element-1" data-mp="23vcjcr61v8b3">
      🌿 Tu próxima consulta empieza con criterio, no con dudas.
    </p>
  </div>;
export function App() {
  useEffect(() => {
    document.title = 'Kit Maestro de Biodescodificación™ | Recursos para Terapeutas';
    const description = 'Kit digital educativo con protocolos, fichas, preguntas de exploración y recursos visuales para terapeutas y facilitadores de Biodescodificación.';
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = description;
  }, []);
  useEffect(() => {
    initMetaPixel();
    trackPixelEvent('ViewContent', {
      content_name: 'Kit Maestro de Biodescodificación',
      content_type: 'product',
      value: 24990,
      currency: 'ARS'
    });
  }, []);
  return <div className="min-h-screen w-full bg-brand-cream font-sans text-brand-text selection:bg-brand-blueMist selection:text-brand-blue" data-id="element-2" data-mp="sunf2d84aoj8">
      <UrgencyBanner data-id="element-3" data-mp="35ghusegjner" />
      <main data-id="element-4" data-mp="34nb3rfi0xwm">
        <Hero data-id="element-5" data-mp="38kvshhq5xim" />
        <PackContents data-id="element-6" data-mp="3uct25gan0gyw" />
        <InitialTestimonials data-id="element-7" data-mp="3udazyhcy738x" />
        <PainPoints data-id="element-8" data-mp="3uc9l01st9wlx" />
        <LaunchOffer data-id="element-9" data-mp="3uevpttobhy0g" />
        <MoreTestimonials data-id="element-10" data-mp="d4o0nv3yoa99" />
        <FAQ data-id="element-11" data-mp="d4xq9hl3gfef" />
        <CostComparison data-id="element-12" data-mp="d3cvbquvaug1" />
        <TransitionPhrase data-id="element-13" data-mp="d2l9v8uzid3h" />
        <EmotionalClose data-id="element-14" data-mp="85l0op2u8u85" />
        <LegalNotice data-id="element-15" data-mp="85bcn71csx53" />
      </main>
      <Footer data-id="element-16" data-mp="86cmx9ajpflr" />
      <FloatingNotification data-id="element-17" data-mp="83i6rtykegy5" />
    </div>;
}